/** 坐标系一行只写短标签；详细说明单独展示，避免与 note 重复堆叠 */
export function getCoordinateSystemLabel(result) {
  if (result.system === 'GCJ02' && (result.source === 'tencent' || result.source === 'amap')) {
    return 'GCJ02 → WGS84（已纠偏）';
  }
  if (result.source === 'baidu' && result.system === 'WGS84') {
    return 'WGS84（百度路径终点已纠偏）';
  }
  if (result.coordinates?.wgs84 && result.system === 'WGS84') {
    return 'WGS84（已纠偏）';
  }
  if (result.coordinates?.gcj02 && result.system === 'GCJ02') {
    return 'GCJ02（已纠偏）';
  }
  return result.system || '未知';
}

/** 用法提示：只保留一句，不再复述纠偏链路全文 */
export function getCoordinateUsageTip(result) {
  const hasWgs = !!(result.coordinates?.wgs84 || result.allCoordinates?.wgs84
    || (result.system === 'WGS84' && result.coordinates?.lat != null));
  const hasBd = !!(result.coordinates?.bd09 || result.allCoordinates?.bd09);
  if (result.source === 'baidu' && hasWgs && hasBd) {
    return 'Mapbox/Locus 请用 WGS84；与百度地图数字对比请用 BD09，勿混用。';
  }
  if (result.note && !/墨卡托|BD09→WGS84|路径终点/.test(result.note)) {
    return result.note;
  }
  return '';
}
